import { Fragment, useEffect, useState } from "react";
import { Box, Button, Divider, Tooltip, Typography } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Swal from "sweetalert2";
import { useAuth } from "../../context/Auth/AuthContext";
import { api } from "../../services/api";
import Spinner from "../../containers/Spinner";
import OrderItem from "../OrderItem/OrderItem";
import { LUX_STATES } from "../../assets/constants";

const Toast = Swal.mixin({
	// toast: true,
	position: "center",
	showConfirmButton: false,
	timer: 2000,
	timerProgressBar: true,
});

const ClosedOrders = () => {
	const [orders, setOrders] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const { userData } = useAuth();

	const finishedOrderCode = "550";

	// const sortOrders = (feature) => {
	// 	orders.sort();
	// };

	// const orderBy = (evt) => {
	// 	switch (evt.target.name) {
	// 		case "menor precio":
	// 			orders.sort((a, b) => a.amount - b.amount);
	// 			console.log(evt.target.name);
	// 			break;
	// 		case "mayor precio":
	// 			orders.sort((a, b) => b.amount - a.amount);
	// 			console.log(evt.target.name);
	// 			break;
	// 		default:
	// 			setOrders(closedOrders);
	// 	}
	// };

	const downloadReceipt = (orderId, nroSuc, nroForm) => {
		api.orders
			.getInvoice({
				clientId: userData.clientId,
				orderId,
				invoiceId: nroSuc + " - " + nroForm,
			})
			.then((res) => {
				if (res.ok) {
					Toast.fire({
						customClass: {
							title: "productAdded",
							icon: "productAddedIcon",
						},
						icon: "success",
						title: "Factura enviada a su email",
					});
				}
			})
			// .then((response) => {
			//   const filename = response.headers
			//     .get('Content-Disposition')
			//     .split('filename=')[1]
			//   response.blob().then((blob) => {
			//     const url = window.URL.createObjectURL(new Blob([blob]))
			//     const link = document.createElement('a')
			//     link.href = url
			//     link.download = filename
			//     document.body.appendChild(link)
			//     link.click()
			//     link.parentNode.removeChild(link)
			//   })
			// })
			.catch((err) => console.log({ err }));
		return;
	};

	useEffect(() => {
		api.orders
			.getLatestOrders(userData.clientId, finishedOrderCode)
			.then((response) => response.json())
			.catch((err) => console.log(err))
			.then((orders) => {
				setOrders(orders);
				setIsLoading(false);
			})
			.catch((err) => console.log(err));
	}, [userData]);

	if (isLoading) {
		return <Spinner />;
	}

	return (
		<Fragment>
			<Divider />
			{orders?.length > 0 ? (
				orders?.map((order) => {
					return (
						<Fragment key={order.idOrder}>
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									flexDirection: { xs: "column", sm: "column" },
									alignItems: { xs: "end", sm: "end" },
									padding: "6px 8px",
									marginBottom: ".5rem",
								}}
							>
								<OrderItem
									orderDate={order.orderDate}
									state={order.state}
									orderItems={order.orderItems}
									amount={order.amount}
									orderId={order.idOrder}
									isPaid={order.isPaid}
									isInClosed={true}
								/>
								{order.stateId !== LUX_STATES.controlado &&
								order.stateId !== LUX_STATES.anulado ? (
									<Box display="flex" alignItems="center" ml={2}>
										<Tooltip title="Descargar factura">
											<Typography
												variant="body1"
												display="flex"
												justifyContent="flex-start"
												alignItems="center"
												flexGrow={1}
												sx={{ fontWeight: "600", whiteSpace: "nowrap" }}
											>
												<Button
													variant="contained"
													style={{ background: "#e9ecef" }}
													size="small"
													onClick={() =>
														downloadReceipt(
															order.nroOc,
															order.nroSuc,
															order.nroForm
														)
													}
												>
													<ReceiptLongIcon
														fontSize="small"
														sx={{ marginRight: 1 }}
													/>
													{`Enviar por email FC Nro. ${order.nroSuc} - ${order.nroForm}`}
												</Button>
											</Typography>
										</Tooltip>
									</Box>
								) : null}
							</Box>
							<Divider />
						</Fragment>
					);
				})
			) : (
				<Box
					sx={{
						minHeight: "calc(100vh - 560px)",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Typography variant="h2" sx={{ color: "#5E5E5E" }}>
						No tiene pedidos finalizados
					</Typography>
				</Box>
			)}
		</Fragment>
	);
};

export default ClosedOrders;
